var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FASTElement, attr } from "@microsoft/fast-element";
import { MultiViewEventNames } from "./multi-view.options.js";
/**
 * MultiView
 * @summary A customizable step component for a wizard-style interface.
 *
 * @example
 * ```html
 * <fabric-multi-view>
 *   <div slot="start">Start Content</div>
 *   <div>Default Content</div>
 *   <div slot="end">End Content</div>
 * </fabric-multi-view>
 * ```
 *
 * @attr {boolean} hidden - Controls the visibility of the component. True if the component is hidden.
 *
 * @prop {boolean} hidden - Determines the hidden state of the multi-view.
 *
 * @slot - Default slot for adding content that can be shown or hidden.
 *
 * @csspart multi-view - Style part for the main container of the multi-view.
 *
 * @method hiddenChanged(oldValue: string, newValue: string) - Called when the `hidden` attribute changes. It emits the `hidden-change` event.
 *
 * @fires hidden-change - Fires when the hidden state of the component changes.
 *
 * @extends FASTElement
 * @tagname fabric-multi-view
 * @public
 */
export class MultiView extends FASTElement {
    constructor() {
        super(...arguments);
        /**
         * Determines the hidden state of the multi-view
         * @public
         * @type {boolean}
         * @attr
         */
        this.hidden = true;
    }
    hiddenChanged(oldValue, newValue) {
        if (oldValue !== newValue) {
            this.$emit(MultiViewEventNames.hiddenChange, this.hidden);
        }
    }
}
__decorate([
    attr({ mode: "boolean" })
], MultiView.prototype, "hidden", void 0);
//# sourceMappingURL=multi-view.js.map